import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/token.vue
var o = {
	name: "DtIconToken",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--token"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Token",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M5.251.701a1.5 1.5 0 0 1 1.498 0h.001l3.5 2A1.5 1.5 0 0 1 11 4v4a1.503 1.503 0 0 1-.75 1.299l-.002.001-3.498 1.999h-.001a1.5 1.5 0 0 1-1.498 0H5.25l-3.498-2-.002-.001A1.5 1.5 0 0 1 1 8V4a1.502 1.502 0 0 1 .75-1.298l.002-.001 3.5-2Zm.749.8a.5.5 0 0 0-.25.067l-.002.001L2.25 3.568A.503.503 0 0 0 2 4v4a.5.5 0 0 0 .25.431s-.001 0 0 0l3.5 2a.5.5 0 0 0 .5 0h.002l3.498-2s0 .001 0 0A.503.503 0 0 0 10 8V4a.5.5 0 0 0-.25-.432c.001 0 0 0 0 0l-3.5-2A.5.5 0 0 0 6 1.501Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		d: "M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=token.js.map